<template>
  <div>
    <div
      id="previousReservationModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">
              確定是否要送出前派單
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearData"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <h4 class="hailing fontSize20 col-md-6">
                預約時間：{{ reservationInfo.reservation_time }} ({{
                  day(reservationInfo.reservation_time)
                }})
              </h4>
              <h4 class="hailing fontSize20 col-md-3">
                車輛數：{{ reservationInfo.cars }}台
              </h4>
              <h4 class="hailing fontSize20 col-md-3" v-show="isLimitDistance">
                公里數：{{ distance / 1000 }}公里
              </h4>
            </div>
            <hr />
            <h4 class="hailing fontSize20">
              上車地點：{{ onLocation }}-{{ onlat }},{{ onlng }}
            </h4>
            <hr />
            <h4 class="hailing fontSize20">
              下車地點：{{ offLocation }}-{{ offlat }},{{ offlng }}
            </h4>
            <hr />
            <div class="row">
              <h4 class="hailing col-md-6 fontSize20">
                乘客服務備註：{{ customerNote }}
              </h4>
              <h4 class="hailing col-md-6 fontSize20">
                人數：{{ user_number }}人
              </h4>
            </div>
            <hr />
            <div class="row">
              <h4 class="hailing col-md-6 fontSize20">乘客姓名：{{ name }}</h4>
              <h4 class="hailing col-md-6 fontSize20">
                派單方式：{{ reserveMethod }}
                <span v-if="reserveMethod === '指定'">
                  {{ this.reservationInfo.callNumberList }}
                </span>
              </h4>
            </div>
            <hr />
            <div class="row">
              <h4 class="hailing col-md-4 fontSize20">
                進線電話：{{ customerPhone }}
              </h4>
              <h4 class="hailing col-md-4 fontSize20">
                篩選服務：{{ selectedList }}
              </h4>
              <h4 class="hailing col-md-4 fontSize20">
                黑名單：{{ blackList }}
              </h4>
            </div>
            <div class="row">
              <h4 class="hailing col-md-4 fontSize20">
                簽單地點：{{ enterpriseOnLocation }}>{{ enterpriseOffLocation }}
              </h4>
              <h4 class="hailing col-md-4 fontSize20">
                簽單備註：{{ enterpriseNote }}
              </h4>
              <h4 class="hailing col-md-4 fontSize20">
                金額：{{ enterpriseAmount }}
              </h4>
            </div>
            <div class="row">
              <DesignationTable
                :list="respones"
                @renewSuccess="renew"
              ></DesignationTable>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearData"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-show="unfinish"
              @click="createReservation"
            >
              送出預約單
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import { getDay } from '@/utils/helper.js'
import DesignationTable from './PreviousDesignationTable'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Record_behavir from '@/assets/js/libs/FirebaseAPI/RecordBill'

const record = new Record_behavir()

export default {
  components: {
    DesignationTable,
  },
  data() {
    return {
      onLocation: '',
      offLocation: '',
      passengerNote: '',
      contactPhone: '',
      customerPhone: '',
      name: '',
      onlng: '',
      onlat: '',
      offlng: '',
      offlat: '',
      method: 'grab' /* grab搶單, application應徵, designation指定 */,
      user_number: 1,
      call_number: '',
      reservationInfo: {},
      respones: [],
      unfinish: true,
      selectedList: '',
      isLimitDistance: false,
      distance: 5000,
      blackList: null,
      enterpriseOnLocation: null,
      enterpriseOffLocation: null,
      enterpriseAmount: null,
      enterpriseNote: null,
      isSubmit: false,
    }
  },
  methods: {
    day(d) {
      return getDay(d)
    },
    renew(val) {
      this.respones[val.index].success = val.success
    },
    openModal(val) {
      this.isSubmit = false
      this._modal('open')
      this.onLocation = val.onLocation
      this.offLocation = val.offLocation
      this.passengerNote = val.passengerNote
      this.contactPhone = val.contactPhone
      this.customerPhone = val.customerPhone
      this.userNumber = val.userNumber
      this.name = val.name
      this.onlng = val.onlng
      this.onlat = val.onlat
      this.offlng = val.offlng
      this.offlat = val.offlat
      this.method = val.takeOrderType
      this.user_number = val.userNumber
      this.selectedList = val.selectedList
      this.isLimitDistance = val.checkedLimit
      this.distance = val.distance
      this.blackList = val.blackList
      this.enterpriseOnLocation = val.enterpriseOnLocation
      this.enterpriseOffLocation = val.enterpriseOffLocation
      this.enterpriseAmount = val.enterpriseAmount
      this.enterpriseNote = val.enterpriseNote
      this.reservationInfo = {
        on_location: val.onLocation,
        off_location: val.offLocation,
        on_location_note: '',
        passenger_note: val.passengerNote,
        payment_method: 0, //現金
        onlng: val.onlng,
        onlat: val.onlat,
        offlng: val.offlng,
        offlat: val.offlat,
        user_number: val.userNumber,
        reservation_type: 0,
        reservation_time: val.reservationTime, // 後端已經加8
        passenger_phone: val.customerPhone,
        passenger_name: val.name,
        service_list: val.service_list,
        callNumberList: val.callNumberList,
        cars: val.cars,
        blackList: val.blackList,
        enterpriseOnLocation: val.enterpriseOnLocation,
        enterpriseOffLocation: val.enterpriseOffLocation,
        enterpriseAmount: val.enterpriseAmount,
        enterpriseNote: val.enterpriseNote,
      }
    },
    closeModal() {
      this._modal('close')
      this.isSubmit = false
    },
    createReservation() {
      if (this.isSubmit) return this.$msg('已派一張單')
      this.isSubmit = true
      let position = 'service'
      if (cookies.get('Flag') === 'manager') {
        position = 'manager'
      }
      let array = []
      this.unfinish = false
      let payload = {
        on_location: this.reservationInfo.on_location,
        off_location: this.reservationInfo.off_location,
        on_location_note: this.reservationInfo.on_location_note,
        payment_method: this.reservationInfo.payment_method, //現金
        onlng: this.reservationInfo.onlng,
        onlat: this.reservationInfo.onlat,
        offlng: this.reservationInfo.offlng,
        offlat: this.reservationInfo.offlat,
        user_number: this.reservationInfo.user_number,
        reservation_type: this.reservationInfo.reservation_type,
        service_list: this.reservationInfo.service_list,
        reservation_time: this.reservationInfo.reservation_time, // 後端已經加8
        passenger_phone: this.reservationInfo.passenger_phone,
        passenger_name: this.reservationInfo.passenger_name,
        passenger_note: this.customerNote,
        cars: this.reservationInfo.cars,
        blackList: this.reservationInfo.blackList,
        enterpriseOnLocation: this.reservationInfo.enterpriseOnLocation,
        enterpriseOffLocation: this.reservationInfo.enterpriseOffLocation,
        enterpriseAmount: this.reservationInfo.enterpriseAmount,
        enterpriseNote: this.reservationInfo.enterpriseNote,
      }
      if (this.method === 'designation') {
        if (callNumberList === null) {
          return
        }
        let callNumberList = this.reservationInfo.callNumberList
        for (let i = 0; i < callNumberList.length; i++) {
          let call = callNumberList[i]
          const payloadCopy = { ...payload }
          payloadCopy.call_number = call
          let create = new Promise((resolve, reject) => {
            this.create(resolve, reject, position, this.method, payloadCopy)
          })
          array.push(create)
        }
        Promise.all(array).then((values) => {
          this.respones = values
        })
        return
      }
      this.creategeneral(
        position,
        this.method,
        payload,
        this.isLimitDistance,
        this.distance,
      )
    },
    clearData() {
      if (!this.unfinish) {
        this.respones = []
        this.unfinish = true
      }
    },
    formatRecord(reservationTime) {
      const str = `預約時間：${reservationTime}, 上車地址：${
        this.onLocation
      }, 下車地址：${this.offLocation ? this.offLocation : '無'}, 乘客人數：${
        this.user_number
      }, 篩選服務：${
        this.selectedList !== '' ? this.selectedList : '無'
      }, 進線電話：${this.customerPhone}, 聯絡電話：${
        this.contactPhone
      },  乘客備註：${
        this.passengerNote && this.passengerNote !== ''
          ? this.passengerNote
          : '無'
      }, 黑名單司機：${
        this.blackList && this.blackList !== '' ? this.blackList : '無'
      }`
      const limitedZone = this.isLimitDistance
        ? `, 限制範圍：${this.distance / 1000}公里`
        : ', 限制範圍：無'
      const designateCallNumber =
        this.reserveMethod === 'designation'
          ? `, 指定呼號：${
              this.callNumberList.length && this.callNumberList[0]
            }`
          : ''
      return str + limitedZone + designateCallNumber
    },
    /* 指定使用 */
    create(resolve, reject, position, method, reservationInfo) {
      if (method !== 'application') {
        BehaviorRecorder.record(
          '點擊',
          '派車頁面',
          `新增預約單(${this.reserveMethod}): ${this.formatRecord(
            reservationInfo.reservation_time,
          )}`,
        )
      }
      API.post(
        `reservation/?position=${position}&method=${method}`,
        reservationInfo,
      )
        .then((res) => {
          if (res.success === true) {
            let recordInfo = {}
            recordInfo.type = '預約單'
            recordInfo.event = '新增預約'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = res.id
            recordInfo.note = '指定使用'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            resolve({
              callNumber: reservationInfo.call_number,
              success: true,
              reservationInfo,
              position,
              result: res.result,
            })
          } else {
            // 搶單失敗也需要提示 因為選擇多台車輛，不能使用指定預約單。
            this.$message({
              showClose: true,
              message: res.result,
              type: 'error',
            })
            reject({
              callNumber: reservationInfo.call_number,
              success: false,
              reservationInfo,
              position,
              result: res.result,
            })
          }
        })
        .catch((err) => {
          reject({
            callNumber: reservationInfo.call_number,
            success: false,
            reservationInfo,
            position,
            result: res.result,
          })
          // alert('新增失敗')
          console.log(err)
        })
    },
    /* 一般預約單使用 */
    creategeneral(
      position,
      method,
      reservationInfo,
      isLimitDistance,
      distance,
    ) {
      if (method !== 'application') {
        BehaviorRecorder.record(
          '點擊',
          '派車頁面',
          `新增預約單(${this.reserveMethod}): ${this.formatRecord(
            reservationInfo.reservation_time,
          )}`,
        )
      }
      API.post(
        `reservation/?position=${position}&method=${method}&distance=${distance}&isLimitDistance=${isLimitDistance}`,
        reservationInfo,
      )
        .then((res) => {
          if (res.success) {
            let recordInfo = {}
            recordInfo.type = '預約單'
            recordInfo.event = '新增預約'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = res.id
            recordInfo.note = '一般預約單使用'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            /* BehaviorRecorder.record(
              '顯示提醒',
              '派車頁面',
              '新增預約單已傳送-成功',
            ) */
            alert('新增成功')
          } else {
            BehaviorRecorder.record(
              '顯示提醒',
              '派車頁面',
              `新增預約單失敗-${res.result}`,
            )
            alert(`新增預約單失敗-${res.result}`)
          }
        })
        .catch((err) => {
          resolve({
            callNumber: reservationInfo.call_number,
            success: false,
            reservationInfo,
            position,
          })
          console.log(err)
        })
    },
    _modal(action) {
      switch (action) {
        case 'open':
          $('#previousReservationModal').modal({
            backdrop: 'static',
            keyboard: true,
          })
          break
        case 'close':
        default:
          $('#previousReservationModal').modal('hide')
      }
    },
  },
  computed: {
    reserveMethod() {
      if (this.method === 'grab') {
        return '搶單'
      } else if (this.method === 'application') {
        return '應徵'
      } else {
        return '指定'
      }
    },
    customerNote() {
      let text = '聯絡電話:' + this.contactPhone
      if (this.passengerNote) {
        text = this.passengerNote + ',' + text
      }
      return text
    },
  },
}
</script>
<style scoped>
.hailing {
  color: #101010;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviousReserveModal.vue